import { useTranslation } from "react-i18next";
import { Box, Center, Container, Image, JsonInput, Stack, Text } from "@mantine/core";
import { StepNavigationButtons } from "@/entities/StepNavigationButtons/StepNavigationButtons";
import { emailStepStore } from "@/entities/StepEmail/store/emailStepStore";
import { basePath } from "@/app/AppRoutes";
import { StepEmailInput } from "@/entities/StepEmail/StepEmailInput";
import { StepEmailPrivacy } from "@/entities/StepEmail/StepEmailPrivacy";
import { appStore, AuthMode } from "@/app/store/appStore";

import styles from "./stepEmail.module.scss";
import GoogleOAuthButton from "@features/GoogleOauth/ui/GoogleOAuthButton";
import FacebookOAuthButton from "@features/FacebookOauth/ui/FacebookOauthButton";
import SteamOpenIDButton from "@features/SteamOpenID/ui/SteamOpenidButton";
import { persistStore } from "@entities/StepFolder/store/persistStore";

export const StepEmailConnect = () => {
	const { t } = useTranslation();
	const appCode = appStore((state) => state.appCode);
	const error = emailStepStore((state) => state.error);
	const startRequest = emailStepStore((state) => state.startRequest);
	const email = emailStepStore((state) => state.email);
	const hint = emailStepStore((state) => state.hint);
	const valueError = emailStepStore((state) => state.valueError);
	const isPrivacy = persistStore((state) => state.isPrivacy);
	const authMode = appStore((state) => state.authMode);
	const profile = persistStore((state) => state.profile);

	function handleNextButton() {
		startRequest(undefined, true);
	}

	const nextBtnDisabled = !!error || !email || !isPrivacy || !!valueError;

	return (
		<Container className={styles.modalWrapper}>
			<Box className={styles.wrapper}>
				<Text className={styles.description}>{t("common.ConnectEmail","Login is success! Please attach your email to continue")}</Text>
				<StepEmailInput handleNextButton={handleNextButton} />

				<Text variant='error'>{hint || valueError}</Text>
				<StepEmailPrivacy />
				{error && <Text variant='error' >{error}</Text>}
			</Box>
			<StepNavigationButtons
				backText={null}
				backOnClick={() => {}}
				backIsDisabled={false}
				nextText={t("common.Attach","Attach" )}
				nextOnClick={handleNextButton}
				nextIsDisabled={nextBtnDisabled}
			/>
		</Container>
	);
};
